import { render } from "./shinsei_Shayoshashiyoedit.vue?vue&type=template&id=25898dc0&scoped=true&ts=true"
import script from "./shinsei_Shayoshashiyoedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Shayoshashiyoedit.vue?vue&type=script&lang=ts"

import "./shinsei_Shayoshashiyoedit.vue?vue&type=style&index=0&id=25898dc0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25898dc0"]])

export default __exports__